import React from 'react'
import {Route, Switch, withRouter} from 'react-router-dom'
import UploadDocument from './UploadDocument'
import ChooseDocument from './ChooseDocument'
import DocumentsHistory from './DocumentsHistory'

const DocumentRoutes =  ({match: {path}}) => (
  <Switch>
    <Route path={`${path}/upload/:category`} component={ChooseDocument} />
    <Route path={`${path}/upload/`} component={UploadDocument} />
    <Route path={`${path}/history`} component={DocumentsHistory} />
    <Route exact path={`${path}`} component={UploadDocument} />
  </Switch>
)

export default withRouter(DocumentRoutes)
